import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d778145"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "frisbuy-fashion-list-item__description"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", null, "Подробнее", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("li", {
    class: "frisbuy-fashion-list-item",
    onClick: _cache[0] || (_cache[0] = () => _ctx.clickPostHandler())
  }, [
    (_ctx.description)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.description), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "frisbuy-fashion-list-item__image",
      ref: "photo",
      style: _normalizeStyle({
        'background-image': `url(${_ctx.postPreviewImage}), url(${_ctx.postPreviewImage})`,
        'background-repeat': 'no-repeat',
      })
    }, null, 4),
    _hoisted_2
  ]))
}